/**
 * Loading placeholder that matches an integration card's tile shape and height
 * exactly, so the card doesn't resize when the integration status lands.
 *
 * Mirrors the loaded layout in the *IntegrationCard.tsx files:
 *   top row (icon + Connect/Disconnect button) → title + description below.
 * If that structure changes, update this file in the same PR.
 */
export function IntegrationCardSkeleton() {
  return (
    <div
      className="card-sm flex flex-col gap-3 h-full"
      aria-hidden="true"
    >
      {/* Top row: icon (left) + button (right) */}
      <div className="flex items-center justify-between gap-3">
        <div className="w-6 h-6 rounded-lg skeleton-shimmer shrink-0" />
        <div className="h-9 w-24 rounded-md skeleton-shimmer" />
      </div>

      {/* Title + description */}
      <div className="flex-1 space-y-2">
        <div className="h-4 w-20 rounded skeleton-shimmer" />
        <div className="h-3 rounded skeleton-shimmer" />
        <div className="h-3 w-2/3 rounded skeleton-shimmer" />
      </div>
    </div>
  );
}
